import React from 'react';
import ReactDOM from 'react-dom/client';
import Unsplash from '../src/Unsplash_api/Unsplash'
// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Unsplash />
  </React.StrictMode>
);


// reportWebVitals();
